import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { getWbImageUrl, toThumbnail } from '../../utils/productImage';

/**
 * Миниатюра товара: cards.image_url; WB CDN fallback только для WB.
 * Принимает task / product / плоские image_url + nm_id.
 */
export default function FulfillmentProductThumb({
  task = null,
  product = null,
  imageUrl = null,
  nmId = null,
  marketplace = null,
  size = 52,
  sx = {},
}) {
  const resolvedImage = imageUrl
    || product?.image_url
    || task?.image_url
    || task?.product?.image_url
    || null;
  const resolvedNm = nmId
    ?? product?.nm_id
    ?? task?.nm_id
    ?? null;
  const mp = String(
    marketplace
    || task?.marketplace
    || product?.marketplace
    || '',
  ).toLowerCase();
  const preferred = resolvedImage ? toThumbnail(resolvedImage) : null;
  const fallback = (mp === 'ozon' || mp === 'yandex') ? null : getWbImageUrl(resolvedNm);
  const [src, setSrc] = useState(preferred || fallback);

  useEffect(() => {
    setSrc(preferred || fallback);
  }, [preferred, fallback]);

  if (!src) {
    return (
      <Box
        sx={{
          width: size,
          height: size,
          borderRadius: 1,
          bgcolor: 'action.hover',
          flexShrink: 0,
          ...sx,
        }}
      />
    );
  }

  return (
    <Box
      component="img"
      src={src}
      alt=""
      onError={() => setSrc((current) => (fallback && current !== fallback ? fallback : null))}
      sx={{
        width: size,
        height: size,
        objectFit: 'contain',
        borderRadius: 1,
        bgcolor: 'action.hover',
        flexShrink: 0,
        ...sx,
      }}
    />
  );
}
